<template>
  <theme-provider v-bind:theme="this.theme">
    <div class="nav">
      <div class="navLeft">
        <a class="logo" href="/" >
          <img src="/static/landing/assets/black-logo-transparent.png" width="180"/>
        </a>
      </div>
      <div :class="modalMenuClasses">
        <BurgerNav></BurgerNav>
      </div>
      <div v-on:click="toggleMenu" :class="menuClasses" type="button">
        <span class="hamburger-box">
          <span class="hamburger-inner">
          </span>
        </span>
      </div>
    </div>
    </div>
    <div class="mainWrapper">
      <router-view></router-view>
    </div>
    <div class="footerWrap"></div>
    <modals-container />
    <modal width="80%" height="80%" name="historyVideoModal">
      <component v-bind:is="this.historyVideoView"></component>
    </modal>
          <!--
          <router-link class="mdl-navigation__link" to="/" @click.native="hideMenu">Home</router-link>
          <router-link class="mdl-navigation__link" to="/post" @click.native="hideMenu">Post a picture</router-link>
          -->
          <!--
          <router-link class="mdl-navigation__link" to="/metronome" @click.native="hideMenu">Metronome</router-link>
          <router-link class="mdl-navigation__link" to="/onboard" @click.native="hideMenu">Onboard (transition POC)</router-link>
          <router-link class="mdl-navigation__link" to="/interval" @click.native="hideMenu">Intervals</router-link>
          <router-link class="mdl-navigation__link" to="/player" @click.native="hideMenu">Player</router-link>
          <router-link class="mdl-navigation__link" to="/video" @click.native="hideMenu">Video</router-link>
          <router-link class="mdl-navigation__link" to="/notation" @click.native="hideMenu">Notation</router-link>
          <router-link class="mdl-navigation__link" to="/design" @click.native="hideMenu">Design System</router-link>
          <router-link class="mdl-navigation__link" to="/public-battles" @click.native="hideMenu">API POC / Public </router-link>
          <router-link class="mdl-navigation__link" to="/private-battles" @click.native="hideMenu">API POC / Private </router-link>
          <router-link class="mdl-navigation__link" to="/payment" @click.native="hideMenu">Payment</router-link>
          -->

  </theme-provider>
</template>

<script>
  import HistoryVideoView from './components/HistoryVideoView.vue'

  export default {
    data () {
      return {
        /*
          This will be the start of modify entire brand for site
        */
        'theme': {
          background: 'black'
        },
        menuClasses: 'hamburger hamburger--collapse',
        modalMenuClasses: 'modalMenu',
        historyVideoView: HistoryVideoView,
        historyVideoUrl: null
      }
    },
    name: 'app',
    methods: {
      /*
      beforeOpen(event) {
        this.historyVideoUrl = event.params.foo
        alert(event.params.foo)
      },
      */
      toggleMenu: function() {
        if (!this.menuClasses.includes("is-active")) {
          this.menuClasses = 'hamburger hamburger--collapse is-active'
          this.modalMenuClasses = 'modalMenu show'
        } else {
          this.menuClasses = 'hamburger hamburger--collapse'
          this.modalMenuClasses = 'modalMenu'
        }
      }
    }
  }
</script>

<style scoped>
/* layout styles */

:root {
  --primary-color: #FF006B;
  --primary-color-hover: #D00057;
}

.mainWrapper {
  height: 100vh;
  background: #eee;
}

.footerWrap{
  @media (max-width: 600px) {
    display: none;
  }
  position: fixed;
  height: 43px;
  width: 100%;
  left: 0;
  bottom: 0;
  background: #ffffff;
}

.nav {

  padding-left: 0px;
  border-bottom: 0px solid #eee;
  display: flex;
  justify-content: space-between;

  @media (max-width: 600px) {
    padding-top: 0px;
  }
}

.navLeft {
  padding-left: 5px;
  padding-top: 5px;
}

.navRightWide {
  word-spacing: 20px;
  padding-right: 45;
  padding-top: 20px;

  @media (max-width: 600px) {
    display: none;
  }
}

.modalMenu{
  display: none;
  width: 100%;
  height: 100%;
  background-color: white;
  position: absolute;
}

/* for toggling display of menu */
.show{
  display: block;
}

.hamburger{
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  color: white;
}

/* colorize burger for in-app experience (opposite colors on landing) */
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  background-color: #000;
}

.hamburger.is-active .hamburger-inner::after {
  background-color: #fff;
}


a.link-sm {
  font-size: 14px;
  line-height: 145%;
  font-weight: 500;
  color: white;
  text-decoration: none;
  padding: 0 0 5px 0;
  border-bottom: 2px solid transparent;
  letter-spacing: 1px;
}

a.link-sm:visited {
  color: white;
}

a.link-sm:hover {
  color: white;
  border-bottom: 2px solid white;
}

a.link-sm:active {
  color: black;
}


a.link-sm_02 {
  font-size: 14px;
  line-height: 145%;
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: none;
  padding: 0 0 5px 0;
  border-bottom: 2px solid transparent;
  letter-spacing: 1px;
}

a.link-sm_02:visited {
  color: var(--primary-color);
}

a.link-sm_02:hover {
  color: var(--primary-color);
  border-bottom: 2px solid var(--primary-color);
}

a.link-sm_02:active {
  color: #FF006B;
}

body {
  margin: 0;
  padding: 0px;
  font-family: "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  width: 100%;
}


/** END LAYOUT **/

</style>



// WEBPACK FOOTER //
// src/App.vue